// Constants for different requests for current reducer
export default {
  update: 'ACTION_UPDATE_CREDENTIALS',
};
